"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
exports.__esModule = true;
exports.Image = void 0;
var react_1 = __importStar(require("react"));
require("intersection-observer");
var react_intersection_observer_1 = require("react-intersection-observer");
var isSsr = typeof window === "undefined";
var universalBtoa = isSsr ? function (str) {
  return Buffer.from(str.toString(), "binary").toString("base64");
} : window.btoa;
var isIntersectionObserverAvailable = isSsr ? false : !!window.IntersectionObserver;
var imageAddStrategy = function imageAddStrategy(_a) {
  var lazyLoad = _a.lazyLoad,
    inView = _a.inView,
    loaded = _a.loaded;
  if (!lazyLoad) {
    return true;
  }
  if (isSsr) {
    return false;
  }
  if (isIntersectionObserverAvailable) {
    return inView || loaded;
  }
  return true;
};
var imageShowStrategy = function imageShowStrategy(_a) {
  var lazyLoad = _a.lazyLoad,
    loaded = _a.loaded;
  if (!lazyLoad) {
    return true;
  }
  if (isSsr) {
    return false;
  }
  if (isIntersectionObserverAvailable) {
    return loaded;
  }
  return true;
};
var Image = function Image(_a) {
  var className = _a.className,
    fadeInDuration = _a.fadeInDuration,
    intersectionTreshold = _a.intersectionTreshold,
    intersectionThreshold = _a.intersectionThreshold,
    intersectionMargin = _a.intersectionMargin,
    pictureClassName = _a.pictureClassName,
    _b = _a.lazyLoad,
    lazyLoad = _b === void 0 ? true : _b,
    style = _a.style,
    pictureStyle = _a.pictureStyle,
    explicitWidth = _a.explicitWidth,
    data = _a.data;
  var _c = react_1.useState(false),
    loaded = _c[0],
    setLoaded = _c[1];
  var handleLoad = react_1.useCallback(function () {
    setLoaded(true);
  }, []);
  var _d = react_intersection_observer_1.useInView({
      threshold: intersectionThreshold || intersectionTreshold || 0,
      rootMargin: intersectionMargin || "0px 0px 0px 0px",
      triggerOnce: true
    }),
    ref = _d[0],
    inView = _d[1],
    _entry = _d[2];
  var absolutePositioning = {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  };
  var addImage = imageAddStrategy({
    lazyLoad: lazyLoad,
    inView: inView,
    loaded: loaded
  });
  var showImage = imageShowStrategy({
    lazyLoad: lazyLoad,
    inView: inView,
    loaded: loaded
  });
  var webpSource = data.webpSrcSet && react_1["default"].createElement("source", {
    srcSet: data.webpSrcSet,
    sizes: data.sizes,
    type: "image/webp"
  });
  var regularSource = data.srcSet && react_1["default"].createElement("source", {
    srcSet: data.srcSet,
    sizes: data.sizes
  });
  var transition = typeof fadeInDuration === "undefined" || fadeInDuration > 0 ? "opacity " + (fadeInDuration || 500) + "ms " + (fadeInDuration || 500) + "ms" : undefined;
  var placeholder = react_1["default"].createElement("div", {
    style: __assign({
      backgroundImage: data.base64 ? "url(" + data.base64 + ")" : undefined,
      backgroundColor: data.bgColor,
      backgroundSize: "cover",
      opacity: showImage ? 0 : 1,
      transition: transition
    }, absolutePositioning)
  });
  var width = data.width,
    aspectRatio = data.aspectRatio;
  var height = data.height || width / aspectRatio;
  var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + width + "\" height=\"" + height + "\"></svg>";
  var sizer = react_1["default"].createElement("img", {
    className: pictureClassName,
    style: __assign({
      display: "block",
      width: explicitWidth ? width + "px" : "100%"
    }, pictureStyle),
    src: "data:image/svg+xml;base64," + universalBtoa(svg),
    role: "presentation"
  });
  return react_1["default"].createElement("div", {
    ref: ref,
    className: className,
    style: __assign(__assign({
      display: explicitWidth ? "inline-block" : "block",
      overflow: "hidden"
    }, style), {
      position: "relative"
    })
  }, sizer, placeholder, addImage && react_1["default"].createElement("picture", null, webpSource, regularSource, data.src && react_1["default"].createElement("img", {
    src: data.src,
    alt: data.alt,
    title: data.title,
    onLoad: handleLoad,
    className: pictureClassName,
    style: __assign(__assign(__assign({}, absolutePositioning), pictureStyle), {
      opacity: showImage ? 1 : 0,
      transition: transition
    })
  })), react_1["default"].createElement("noscript", null, react_1["default"].createElement("picture", null, webpSource, regularSource, data.src && react_1["default"].createElement("img", {
    src: data.src,
    alt: data.alt,
    title: data.title,
    className: pictureClassName,
    style: __assign(__assign({}, absolutePositioning), pictureStyle),
    loading: "lazy"
  }))));
};
exports.Image = Image;